"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorNestedList = exports.CSS = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var image_button_1 = require("../../../components/button/image.button");
var icons_1 = require("../../../components/icon/icons");
var input_1 = require("../../../components/input/input");
var input_state_1 = require("../../../components/input/input.state");
var input_state_group_1 = require("../../../components/input/input.state.group");
var modal_service_1 = require("../../../components/modal/modal.service");
var theme_1 = require("../../../components/theme");
var theme_util_1 = require("../../../components/theme.util");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var form_field_editor_1 = require("./form.field.editor");
exports.CSS = {
    container: 'c-FdcNestedList',
    list: 'c-FdcNestedList__list',
    option: 'c-FdcNestedList__option',
    value: 'c-FdcNestedList__value',
    title: 'c-FdcNestedList__title',
    color: 'c-FdcNestedList__color',
    colorTitle: 'c-FdcNestedList__colorTitle',
    isReadOnly: 'FdcNestedList--is-read-only',
    isReadWrite: 'FdcNestedList--is-read-write',
    isSelected: 'FdcNestedList--is-selected',
    isSelectable: 'FdcNestedList--is-selectable'
};
var colorPickerSize = 32;
var colorPickerMargin = 20;
var inputWidth = 248;
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = {
        display: 'flex'
    },
    _a[exports.CSS.list] = tslib_1.__assign(tslib_1.__assign({}, theme_util_1.IkeCssUtil.Flex.column), { width: '100%', 'max-width': '340px' }),
    _a[exports.CSS.title] = {
        display: 'flex',
        alignItems: 'center',
        height: '20px',
        'text-align': 'left',
        'margin-bottom': theme_1.DefaultTheme.space(4),
        '& .mdl-textfield': {
            width: "".concat(inputWidth, "px")
        },
        '& input': {
            'font-weight': theme_1.DefaultTheme.font.weight.bold
        }
    },
    _a[exports.CSS.value] = tslib_1.__assign(tslib_1.__assign({}, theme_util_1.IkeCssUtil.Flex.centerVertical), { 'text-align': 'left', 'text-transform': 'none', height: '36px', '& input': {
            outline: 'none'
        }, '& button': {
            width: '300px'
        }, '& .mdl-textfield': {
            width: "".concat(inputWidth, "px")
        } }),
    _a[exports.CSS.isSelected] = {
        color: theme_1.DefaultTheme.font.color.link
    },
    _a[exports.CSS.isSelectable] = {
        cursor: 'pointer'
    },
    _a[exports.CSS.colorTitle] = (_b = {
            width: "".concat(colorPickerSize, "px"),
            marginRight: "".concat(colorPickerMargin, "px"),
            'font-weight': 'bold',
            color: theme_1.DefaultTheme.font.color.supporting
        },
        _b["& + .mdl-textfield"] = {
            width: "".concat(300 - colorPickerSize - colorPickerMargin, "px")
        },
        _b),
    _a[exports.CSS.color] = (_c = {
            width: "".concat(colorPickerSize, "px"),
            height: '20px',
            overflow: 'hidden',
            boxSizing: 'border-box',
            borderRadius: '4px',
            border: '2px solid #c9c9c9',
            marginRight: "".concat(colorPickerMargin, "px")
        },
        _c['& input[type=color]'] = {
            width: 'calc(100% + 12px)',
            height: 'calc(100% + 12px)',
            padding: 0,
            margin: '-6px',
            cursor: 'pointer'
        },
        _c["& + .".concat(exports.CSS.value, " > .mdl-textfield")] = {
            width: "calc(300px - ".concat(colorPickerSize + colorPickerMargin, "px)")
        },
        _c),
    _a));
/** Maximum number of levels to support. Too many becomes difficult to edit and visualize. */
var MAX_OPTIONS = 3;
var FormFieldEditorNestedList = /** @class */ (function (_super) {
    tslib_1.__extends(FormFieldEditorNestedList, _super);
    function FormFieldEditorNestedList(designer, field) {
        var _this = _super.call(this, designer, field) || this;
        _this.selected = mobx_1.observable.array();
        _this.stateGroups = [];
        _this.isAnalyst = services_1.Services.User.isIkeAnalyst(services_1.Services.User.current);
        // Init the selected to the first option every level
        _this.builder = field.Mutator.builder;
        var options = _this.builder.options;
        if (options != null && Array.isArray(options.values) && options.values.length > 0) {
            _this.setSelected(0, 0);
        }
        if (options == null) {
            _this.builder.createGroup(_this.getOptionTitle(0));
        }
        return _this;
    }
    FormFieldEditorNestedList.prototype.viewInfoRW = function () {
        return (0, mithril_1.m)('div', { className: exports.CSS.container }, this.viewNestedOptionsRW(this.field.options));
    };
    FormFieldEditorNestedList.prototype.viewInfoRO = function () {
        return (0, mithril_1.m)('div', { className: exports.CSS.container }, this.viewNestedOptionsRO(this.field.options));
    };
    FormFieldEditorNestedList.prototype.getCurrentOption = function (path) {
        var opts = this.field.options;
        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
            var pathIndex = path_1[_i];
            if (opts == null || opts.values == null || pathIndex >= opts.values.length) {
                return null;
            }
            opts = opts.values[pathIndex].options;
        }
        if (opts == null || opts.values == null) {
            return null;
        }
        return opts;
    };
    FormFieldEditorNestedList.prototype.getCurrentValue = function (path, offset) {
        var opts = this.getCurrentOption(path);
        if (opts == null) {
            return null;
        }
        return opts.values[offset];
    };
    FormFieldEditorNestedList.prototype.getCurrentValueString = function (path, offset, type) {
        var node = this.getCurrentValue(path, offset);
        if (node == null) {
            return '';
        }
        if (type === input_state_1.InputStateTypes.COLOR) {
            return node.color;
        }
        return node.value;
    };
    FormFieldEditorNestedList.prototype.destroyStateGroup = function (index) {
        // If no change is required, avoid touching the array and causing a reaction.
        if (index >= this.stateGroups.length) {
            return;
        }
        for (var i = index; i < this.stateGroups.length; i++) {
            this.stateGroups[i].destroy();
        }
        this.stateGroups = this.stateGroups.slice(0, index);
    };
    FormFieldEditorNestedList.prototype.getStateGroup = function (index) {
        var existing = this.stateGroups[index];
        if (existing == null) {
            existing = this.stateGroups[index] = new input_state_group_1.IkeInputStateGroup();
            this.state.add(existing);
        }
        return existing;
    };
    FormFieldEditorNestedList.prototype.getColorState = function (index, offset) {
        var _this = this;
        var path = this.selected.slice(0, index);
        var currentSelection = path.join('__');
        var fieldKey = "".concat(currentSelection, ":").concat(offset, ":color");
        var state = this.getStateGroup(index);
        var editState = state.get(fieldKey);
        if (editState == null) {
            editState = new input_state_1.InputState(i18n_1.T.EMPTY, fieldKey, input_state_1.InputStateTypes.COLOR);
            state.add(editState);
            editState.onValue(function (value) {
                var group = _this.builder.getGroup(path);
                if (group == null) {
                    var groupTitle = _this.getOptionTitle(index);
                    _this.builder.getValue(path)
                        .createGroup(groupTitle)
                        .createValue(value);
                }
                else if (offset < group.size) {
                    group.getValue(offset).setColor(value);
                }
                else {
                    group.createValue(value);
                }
                _this.applyChanges();
            });
            editState.setValue(this.getCurrentValueString(path, offset, input_state_1.InputStateTypes.COLOR) || '#a0aec0');
            editState.setPlaceholder((0, i18n_1.Translate)(i18n_1.T.FIELD_NESTED_LIST_VALUE));
            editState.reaction(function () { return editState.focused; }, function (focused) { return focused && _this.setSelected(index, offset); });
        }
        editState.isRequired = this.isExistingOption(path, offset);
        return editState;
    };
    FormFieldEditorNestedList.prototype.getValueState = function (index, offset) {
        var _this = this;
        var path = this.selected.slice(0, index);
        var currentSelection = path.join('__');
        var fieldKey = "".concat(currentSelection, ":").concat(offset);
        var state = this.getStateGroup(index);
        var editState = state.get(fieldKey);
        if (editState == null) {
            editState = new input_state_1.InputState(i18n_1.T.EMPTY, fieldKey, input_state_1.InputStateTypes.TEXT);
            state.add(editState);
            editState.onValue(function (value) {
                var group = _this.builder.getGroup(path);
                if (group == null) {
                    var groupTitle = _this.getOptionTitle(index);
                    _this.builder.getValue(path)
                        .createGroup(groupTitle)
                        .createValue(value);
                }
                else if (offset < group.size) {
                    group.getValue(offset).setValue(value);
                }
                else {
                    group.createValue(value);
                }
                _this.applyChanges();
            });
            editState.setValue(this.getCurrentValueString(path, offset));
            editState.setPlaceholder((0, i18n_1.Translate)(i18n_1.T.FIELD_NESTED_LIST_VALUE));
            editState.reaction(function () { return editState.focused; }, function (focused) { return focused && _this.setSelected(index, offset); });
        }
        editState.isRequired = this.isExistingOption(path, offset);
        return editState;
    };
    FormFieldEditorNestedList.prototype.isExistingOption = function (path, offset) {
        var opts = this.getCurrentOption(path);
        // This is a placeholder option for a new group and not required.
        if (opts == null) {
            return false;
        }
        // This is a placeholder option for an empty group and is required.
        if (opts.values.length === 0) {
            return true;
        }
        // This is a placeholder option for a non-empty group and is not required.
        if (offset >= opts.values.length) {
            return false;
        }
        // All other options are required.
        return true;
    };
    FormFieldEditorNestedList.prototype.getOptionTitleState = function (index) {
        var _this = this;
        var path = this.selected.slice(0, index);
        var currentSelection = path.join('__');
        var fieldKey = "".concat(currentSelection, ":title");
        var state = this.getStateGroup(index);
        var level = index + 1;
        var editState = state.get(fieldKey);
        if (editState == null) {
            editState = new input_state_1.InputState(i18n_1.T.EMPTY, fieldKey, input_state_1.InputStateTypes.TEXT);
            state.add(editState);
            editState.isRequired = true;
            editState.onValue(function (value) {
                var group = _this.builder.getGroup(path);
                if (group != null) {
                    group.setTitle(value);
                }
                else {
                    _this.builder.getValue(path)
                        .createGroup(value);
                }
                _this.applyChanges();
            });
            var opt = this.getCurrentOption(path);
            if (opt != null && opt.title != null && opt.title.length > 0) {
                editState.setValue(opt.title);
            }
            else {
                editState.setValue((0, i18n_1.Translate)(i18n_1.T.FIELD_NESTED_LIST_TITLE, { level: level }));
            }
            editState.setPlaceholder((0, i18n_1.Translate)(i18n_1.T.FIELD_NESTED_LIST_TITLE, { level: level }));
        }
        return editState;
    };
    FormFieldEditorNestedList.prototype.getOptionTitle = function (index) {
        return this.getOptionTitleState(index).value;
    };
    FormFieldEditorNestedList.prototype.confirmDeleteValue = function (index, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var path, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = tslib_1.__spreadArray(tslib_1.__spreadArray([], this.selected.slice(0, index), true), [offset], false);
                        if (this.builder.getGroup(path) == null) {
                            this.deleteValue(index, offset);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, modal_service_1.ModalService.open({
                                title: (0, i18n_1.Translate)(i18n_1.T.FORM_FIELD_NESTED_LIST_DELETE_TITLE),
                                content: (0, i18n_1.Translate)(i18n_1.T.FORM_FIELD_NESTED_LIST_DELETE_CONFIRM),
                                hasCancel: true,
                                okName: i18n_1.T.FORM_FIELD_NESTED_LIST_DELETE
                            })];
                    case 1:
                        result = _a.sent();
                        if (result.ok) {
                            this.deleteValue(index, offset);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FormFieldEditorNestedList.prototype.deleteValue = function (index, offset) {
        var path = this.selected.slice(0, index);
        this.builder.getGroup(path).deleteValue(offset);
        if (this.builder.getGroup(path).size === 0) {
            var prevPath = path.slice(0, path.length - 1);
            if (prevPath.length > 0) {
                var newIndex = path[path.length - 1];
                var oldValue = this.builder.getGroup(prevPath).getValue(newIndex);
                this.builder.getGroup(prevPath).deleteValue(newIndex);
                this.builder.getGroup(prevPath).createValue(oldValue.value, null, oldValue.color, newIndex);
            }
        }
        this.applyChanges();
        this.destroyStateGroup(index);
        this.setSelected(index, Math.max(0, offset - 1));
    };
    FormFieldEditorNestedList.prototype.viewNestedOptionButton = function (value, isSelected, index, offset) {
        var _this = this;
        var className = "mdl-button ".concat(exports.CSS.value, " ").concat(exports.CSS.isReadOnly);
        if (isSelected) {
            className += ' ' + exports.CSS.isSelected;
        }
        else {
            className += ' ' + exports.CSS.isSelectable;
        }
        return (0, mithril_1.m)('button', {
            className: className,
            onclick: isSelected ? null : function () { return _this.setSelected(index, offset); }
        }, value);
    };
    FormFieldEditorNestedList.prototype.viewNestedOptionsRW = function (opt) {
        var editor = this;
        function makeNode(child, index, offset, isSelected) {
            var className = "".concat(exports.CSS.value);
            if (isSelected) {
                className += ' ' + exports.CSS.isSelected;
            }
            var showColor = editor.field.isMapColorField && index === 0;
            var children = [];
            if (editor.isLocked && !editor.isAnalyst) {
                children.push(editor.viewNestedOptionButton(child.value, isSelected, index, offset));
            }
            else {
                if (showColor) {
                    children.push((0, mithril_1.m)('div', { className: exports.CSS.color }, input_1.Input.view(editor.getColorState(index, offset), { rawInputOnly: true })));
                }
                children.push((0, mithril_1.m)('div', { className: className }, input_1.Input.view(editor.getValueState(index, offset))));
            }
            if (isSelected) {
                children.push(image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, { onclick: function () { return editor.confirmDeleteValue(index, offset); } }));
            }
            return (0, mithril_1.m)('div', { className: className }, children);
        }
        return this.viewNestedOptions(opt, makeNode);
    };
    FormFieldEditorNestedList.prototype.viewNestedOptionsRO = function (opt) {
        var editor = this;
        function makeNode(child, index, offset, isSelected) {
            return editor.viewNestedOptionButton(child.value, isSelected, index, offset);
        }
        return this.viewNestedOptions(opt, makeNode);
    };
    FormFieldEditorNestedList.prototype.viewNestedOptions = function (opt, nodeMaker, index) {
        if (index === void 0) { index = 0; }
        if (opt == null) {
            if (index > this.selected.length || index >= MAX_OPTIONS) {
                return [];
            }
            opt = { title: '', values: [] };
        }
        var children = [this.viewOptionTitle(opt, index)];
        var levels = [];
        for (var offset = 0; offset < opt.values.length; offset++) {
            var child = opt.values[offset];
            var isSelected = this.selected.length > index && offset === this.selected[index];
            var node = void 0;
            if (isSelected) {
                levels = this.viewNestedOptions(child.options, nodeMaker, index + 1);
                node = nodeMaker(child, index, offset, isSelected);
            }
            else {
                node = nodeMaker(child, index, offset, isSelected);
            }
            children.push(node);
        }
        if (!(this.isLocked && !this.isAnalyst) && this.designer.isEditing) {
            children.push(nodeMaker({ value: '' }, index, opt.values.length, false));
        }
        return tslib_1.__spreadArray([
            (0, mithril_1.m)('div', { className: exports.CSS.list }, children)
        ], levels, true);
    };
    FormFieldEditorNestedList.prototype.viewOptionTitle = function (opt, index) {
        var children = [];
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) && this.field.isMapColorField && index === 0) {
            children.push((0, mithril_1.m)('div', { className: exports.CSS.colorTitle }, (0, i18n_1.Translate)(i18n_1.T.COLOR)));
        }
        if (!this.isLocked && this.designer.isEditing) {
            var inputState = this.getOptionTitleState(index);
            children.push(input_1.Input.view(inputState));
            return (0, mithril_1.m)('div', { className: exports.CSS.title }, children);
        }
        children.push(opt.title);
        return (0, mithril_1.m)('div', { className: exports.CSS.title }, children);
    };
    FormFieldEditorNestedList.prototype.setSelected = function (index, offset) {
        if (this.selected.length > index && this.selected[index] === offset) {
            return;
        }
        this.destroyStateGroup(index);
        if (this.selected.length > index) {
            this.selected.splice(index);
        }
        this.selected.push(offset);
        // Set the selected to the first value down the nest
        var nestedValue = this.getCurrentValue(this.selected.slice(), offset);
        if (nestedValue == null) {
            return;
        }
        var opt = nestedValue.options;
        while (opt != null && Array.isArray(opt.values)) {
            var current = opt.values[0];
            if (current == null) {
                break;
            }
            this.selected.push(0);
            opt = current.options;
        }
    };
    FormFieldEditorNestedList.prototype.applyChanges = function () {
        this.field.Mutator.init(this.builder.options);
    };
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditorNestedList.prototype, "deleteValue", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FormFieldEditorNestedList.prototype, "setSelected", null);
    return FormFieldEditorNestedList;
}(form_field_editor_1.FormFieldEditor));
exports.FormFieldEditorNestedList = FormFieldEditorNestedList;
//# sourceMappingURL=form.field.editor.nested.list.js.map